import { coerceBooleanProperty } from '@angular/cdk/coercion';

import {
    ChangeDetectorRef,
    Component,
    inject,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    SimpleChanges,
    ViewEncapsulation,
} from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { DavesaLoadingService } from '@davesa/services/loading';
import { asapScheduler, observeOn, Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'davesa-loading-bar',
    templateUrl: './loading-bar.component.html',
    styleUrls: ['./loading-bar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    exportAs: 'davesaLoadingBar',
    standalone: true,
    imports: [MatProgressBarModule]
})
export class DavesaLoadingBarComponent implements OnChanges, OnInit, OnDestroy {
    private _davesaLoadingService = inject(DavesaLoadingService);
    private _changeDetectorRef = inject(ChangeDetectorRef);

    @Input() autoMode: boolean = true;
    mode: 'determinate' | 'indeterminate';
    progress: number = 0;
    show: boolean = false;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On changes
     *
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {
        // Auto mode
        if ('autoMode' in changes) {
            // Set the auto mode in the service
            this._davesaLoadingService.setAutoMode(
                coerceBooleanProperty(changes.autoMode.currentValue)
            );
        }
    }

    /**
     * On init
     */
    ngOnInit(): void {
        // Requests can start mid change detection (e.g. from a lower component's ngOnInit), after this
        // bar was already checked; applying values right after the check avoids NG0100
        this._davesaLoadingService.mode$
            .pipe(observeOn(asapScheduler), takeUntil(this._unsubscribeAll))
            .subscribe((value) => {
                this.mode = value;
                this._changeDetectorRef.markForCheck();
            });

        this._davesaLoadingService.progress$
            .pipe(observeOn(asapScheduler), takeUntil(this._unsubscribeAll))
            .subscribe((value) => {
                this.progress = value;
                this._changeDetectorRef.markForCheck();
            });

        this._davesaLoadingService.show$
            .pipe(observeOn(asapScheduler), takeUntil(this._unsubscribeAll))
            .subscribe((value) => {
                this.show = value;
                this._changeDetectorRef.markForCheck();
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
